import { render, staticRenderFns } from "./RegisteredControlAccessCards.vue?vue&type=template&id=3c25b81a&"
import script from "./RegisteredControlAccessCards.vue?vue&type=script&lang=js&"
export * from "./RegisteredControlAccessCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports